import { FAILURE, REQUEST, SUCCESS, createReducer, updateObject } from '../../../store'
import { TASK_STATUS_FILTER_VALUES } from '../constants'
import {
  LOAD_TASK_CATEGORIES,
  LOAD_TASK_USER_LIST,
  LOAD_TASK_ASSIGNEE_MYSELF,
  REGISTER_NEW_TASK,
  LOAD_TASKS,
  UPDATE_TASK,
  DELETE_TASK,
  DELETE_SELECTED_TASKS,
  LOAD_MORE_TASKS,
  LOAD_UNREAD_TASKS,
  UPDATE_READ_STATUS,
  UPDATE_STATUS_FILTER
} from './constants'

export const initialState = {
  taskCategories: {
    isLoading: false,
    data: {
      myTasks: [],
      departments: [],
      attributes: []
    },
    error: null
  },
  taskUserList: {
    isLoading: false,
    data: [],
    error: null
  },
  newTask: {
    isLoading: false,
    error: null
  },
  tasks: {
    isLoading: false,
    isMoreLoading: false,
    data: {
      totalCount: 0,
      isLastPage: false,
      items: []
    },
    error: null
  },
  unreadTasks: {
    isLoading: false,
    data: {
      hasUnread: false
    },
    error: null
  },
  statusFIlter: TASK_STATUS_FILTER_VALUES.UNCOMPLETED
}

function loadTaskCategories(state) {
  return updateObject(state, {
    taskCategories: {
      ...state.taskCategories,
      isLoading: true
    }
  })
}

function loadTaskCategoriesSuccess(state, { data }) {
  return updateObject(state, {
    taskCategories: {
      ...state.taskCategories,
      isLoading: false,
      data
    }
  })
}

function loadTaskCategoriesError(state, { error }) {
  return updateObject(state, {
    taskCategories: {
      ...state.taskCategories,
      isLoading: false,
      error
    }
  })
}

function loadTaskUserList(state) {
  return updateObject(state, {
    taskUserList: {
      ...state.taskUserList,
      isLoading: true
    }
  })
}

function loadTaskUserListSuccess(state, { data }) {
  return updateObject(state, {
    taskUserList: {
      ...state.taskUserList,
      isLoading: false,
      data
    }
  })
}

function loadTaskUserListError(state, { error }) {
  return updateObject(state, {
    taskUserList: {
      ...state.taskUserList,
      isLoading: false,
      error
    }
  })
}

function loadAssigneeMyself(state, { payload }) {
  return updateObject(state, {
    taskUserList: {
      ...state.taskUserList,
      data: [payload]
    }
  })
}

function registerNewTask(state) {
  return updateObject(state, {
    newTask: {
      ...state.newTask,
      isLoading: true
    }
  })
}

function registerNewTaskSuccess(state, { data }) {
  return updateObject(state, {
    newTask: {
      ...state.newTask,
      isLoading: false,
      data
    }
  })
}

function registerNewTaskError(state, { error }) {
  return updateObject(state, {
    newTask: {
      ...state.newTask,
      isLoading: false,
      error
    }
  })
}

function loadTasks(state) {
  return updateObject(state, {
    tasks: {
      ...state.tasks,
      isLoading: true
    }
  })
}

function loadTasksSuccess(state, { data }) {
  return updateObject(state, {
    tasks: {
      ...state.tasks,
      isLoading: false,
      data
    }
  })
}

function loadTasksError(state, { error }) {
  return updateObject(state, {
    tasks: {
      ...state.tasks,
      isLoading: false,
      error
    }
  })
}

function updateTask(state) {
  return updateObject(state, {
    tasks: {
      ...state.tasks,
      isLoading: true
    }
  })
}

function updateTaskSuccess(state) {
  return updateObject(state, {
    tasks: {
      ...state.tasks,
      isLoading: false
    }
  })
}

function updateTaskError(state, { error }) {
  return updateObject(state, {
    tasks: {
      ...state.tasks,
      isLoading: false,
      error
    }
  })
}

function deleteTask(state) {
  return updateObject(state, {
    tasks: {
      ...state.tasks,
      isLoading: true
    }
  })
}

function deleteTaskSuccess(state) {
  return updateObject(state, {
    tasks: {
      ...state.tasks,
      isLoading: false
    }
  })
}

function deleteTaskError(state, { error }) {
  return updateObject(state, {
    tasks: {
      ...state.tasks,
      isLoading: false,
      error
    }
  })
}

function deleteSelectedTasks(state) {
  return updateObject(state, {
    tasks: {
      ...state.tasks,
      isLoading: true
    }
  })
}

function deleteSelectedTasksSuccess(state) {
  return updateObject(state, {
    tasks: {
      ...state.tasks,
      isLoading: false
    }
  })
}

function deleteSelectedTasksError(state, { error }) {
  return updateObject(state, {
    tasks: {
      ...state.tasks,
      isLoading: false,
      error
    }
  })
}

function loadMoreTasks(state) {
  return updateObject(state, {
    tasks: {
      ...state.tasks,
      isMoreLoading: true
    }
  })
}

function loadMoreTasksSuccess(state, { data }) {
  return updateObject(state, {
    tasks: {
      ...state.tasks,
      isMoreLoading: false,
      data: {
        totalCount: data.totalCount,
        isLastPage: data.isLastPage,
        items: [...state.tasks.data.items, ...data.items]
      }
    }
  })
}

function loadMoreTasksError(state, { error }) {
  return updateObject(state, {
    tasks: {
      ...state.tasks,
      isMoreLoading: false,
      error
    }
  })
}

function loadUnreadTasks(state) {
  return updateObject(state, {
    unreadTasks: {
      ...state.unreadTasks,
      isLoading: true
    }
  })
}

function loadUnreadTasksSuccess(state, { data }) {
  return updateObject(state, {
    unreadTasks: {
      ...state.unreadTasks,
      isLoading: false,
      data
    }
  })
}

function loadUnreadTasksError(state, { error }) {
  return updateObject(state, {
    unreadTasks: {
      ...state.unreadTasks,
      isLoading: false,
      error
    }
  })
}

function updateReadStatus(state) {
  return updateObject(state, {
    unreadTasks: {
      ...state.unreadTasks,
      isLoading: true
    }
  })
}

function updateReadStatusSuccess(state) {
  return updateObject(state, {
    unreadTasks: {
      ...state.unreadTasks,
      isLoading: false
    }
  })
}

function updateReadStatusError(state, { error }) {
  return updateObject(state, {
    unreadTasks: {
      ...state.unreadTasks,
      isLoading: false,
      error
    }
  })
}

function updateStatusFilter(state, { payload }) {
  return updateObject(state, {
    statusFIlter: payload
  })
}

export default createReducer(initialState, {
  [REQUEST(LOAD_TASK_CATEGORIES)]: loadTaskCategories,
  [SUCCESS(LOAD_TASK_CATEGORIES)]: loadTaskCategoriesSuccess,
  [FAILURE(LOAD_TASK_CATEGORIES)]: loadTaskCategoriesError,

  [REQUEST(LOAD_TASK_USER_LIST)]: loadTaskUserList,
  [SUCCESS(LOAD_TASK_USER_LIST)]: loadTaskUserListSuccess,
  [FAILURE(LOAD_TASK_USER_LIST)]: loadTaskUserListError,
  [LOAD_TASK_ASSIGNEE_MYSELF]: loadAssigneeMyself,

  [REQUEST(REGISTER_NEW_TASK)]: registerNewTask,
  [SUCCESS(REGISTER_NEW_TASK)]: registerNewTaskSuccess,
  [FAILURE(REGISTER_NEW_TASK)]: registerNewTaskError,

  [REQUEST(LOAD_TASKS)]: loadTasks,
  [SUCCESS(LOAD_TASKS)]: loadTasksSuccess,
  [FAILURE(LOAD_TASKS)]: loadTasksError,

  [REQUEST(UPDATE_TASK)]: updateTask,
  [SUCCESS(UPDATE_TASK)]: updateTaskSuccess,
  [FAILURE(UPDATE_TASK)]: updateTaskError,

  [REQUEST(DELETE_TASK)]: deleteTask,
  [SUCCESS(DELETE_TASK)]: deleteTaskSuccess,
  [FAILURE(DELETE_TASK)]: deleteTaskError,

  [REQUEST(DELETE_SELECTED_TASKS)]: deleteSelectedTasks,
  [SUCCESS(DELETE_SELECTED_TASKS)]: deleteSelectedTasksSuccess,
  [FAILURE(DELETE_SELECTED_TASKS)]: deleteSelectedTasksError,

  [REQUEST(LOAD_MORE_TASKS)]: loadMoreTasks,
  [SUCCESS(LOAD_MORE_TASKS)]: loadMoreTasksSuccess,
  [FAILURE(LOAD_MORE_TASKS)]: loadMoreTasksError,

  [REQUEST(LOAD_UNREAD_TASKS)]: loadUnreadTasks,
  [SUCCESS(LOAD_UNREAD_TASKS)]: loadUnreadTasksSuccess,
  [FAILURE(LOAD_UNREAD_TASKS)]: loadUnreadTasksError,

  [REQUEST(UPDATE_READ_STATUS)]: updateReadStatus,
  [SUCCESS(UPDATE_READ_STATUS)]: updateReadStatusSuccess,
  [FAILURE(UPDATE_READ_STATUS)]: updateReadStatusError,

  [UPDATE_STATUS_FILTER]: updateStatusFilter
})
